/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionUnitsLibrary = function (saved) {
    saved = saved || {};

    this.discovered = cleverapps.listFromBit(Merge2MissionFamilies.decodeCodes(saved.discovered || {}));
    this.unclaimed = cleverapps.listFromBit(Merge2MissionFamilies.decodeCodes(saved.unclaimed || {}));
    this.activations = saved.activations || 0;
    this.groupRewarded = saved.groupRewarded || {};
    this.libraryRewarded = Boolean(saved.libraryRewarded);

    this.newUnits = [];
};

Merge2MissionUnitsLibrary.getActivationsTotal = function () {
    return Merge2MissionFamilies.getGroups().reduce((total, group) => total + group.activations, 0);
};

Merge2MissionUnitsLibrary.getTotal = function () {
    return Merge2MissionFamilies.getGroups().reduce(
        (total, group) => total + Merge2MissionFamilies.getGroupItems(group).length + group.activations,
        0
    );
};

Merge2MissionUnitsLibrary.prototype.isCountable = function (unit) {
    return Merge2MissionFamilies.isCollectable(unit.code) && !unit.findComponent(Merge2MissionGroundedComponent);
};

Merge2MissionUnitsLibrary.prototype.isDiscovered = function (code, stage) {
    return Boolean(this.discovered[code] && this.discovered[code][stage]);
};

Merge2MissionUnitsLibrary.prototype.isUnclaimed = function (code, stage) {
    return Boolean(this.unclaimed[code] && this.unclaimed[code][stage]);
};

Merge2MissionUnitsLibrary.prototype.restore = function (unit) {
    if (!this.isCountable(unit) || this.isDiscovered(unit.code, unit.stage)) {
        return false;
    }

    const family = this.discovered[unit.code] = this.discovered[unit.code] || {};
    family[unit.stage] = true;

    return true;
};

Merge2MissionUnitsLibrary.prototype.discover = function (unit) {
    if (!this.restore(unit)) {
        return false;
    }

    const family = this.unclaimed[unit.code] = this.unclaimed[unit.code] || {};
    family[unit.stage] = true;

    if (Merge2MissionFamilies.isPresented(unit.code, unit.stage)) {
        this.newUnits.push({ code: unit.code, stage: unit.stage });
    }

    return true;
};

Merge2MissionUnitsLibrary.prototype.takeNewUnits = function () {
    const units = this.newUnits;
    this.newUnits = [];

    return units;
};

Merge2MissionUnitsLibrary.prototype.registerActivation = function () {
    if (this.activations >= Merge2MissionUnitsLibrary.getActivationsTotal()) {
        return;
    }

    this.activations++;
};

Merge2MissionUnitsLibrary.prototype.getActivations = function () {
    return this.activations;
};

Merge2MissionUnitsLibrary.prototype.count = function () {
    const discovered = Merge2MissionFamilies.getGroups().reduce((total, group) => (
        total + Merge2MissionFamilies.getGroupItems(group).filter((item) => this.isDiscovered(item.code, item.stage)).length
    ), 0);

    return discovered + this.activations;
};

Merge2MissionUnitsLibrary.prototype.isCompleted = function () {
    return this.count() >= Merge2MissionUnitsLibrary.getTotal();
};

Merge2MissionUnitsLibrary.prototype.isLibraryRewarded = function () {
    return this.libraryRewarded;
};

Merge2MissionUnitsLibrary.prototype.isGroupCompleted = function (group) {
    const config = Merge2MissionFamilies.getGroup(group);
    const unitsCompleted = Merge2MissionFamilies.getGroupItems(config).every((item) => this.isDiscovered(item.code, item.stage));

    if (!unitsCompleted) {
        return false;
    }

    return config.activations === 0 || this.activations >= config.activations;
};

Merge2MissionUnitsLibrary.prototype.isGroupRewarded = function (group) {
    return Boolean(this.groupRewarded[group]);
};

Merge2MissionUnitsLibrary.prototype.hasGroupUnclaimed = function (group) {
    return Merge2MissionFamilies.getGroupItems(Merge2MissionFamilies.getGroup(group)).some((item) => this.isUnclaimed(item.code, item.stage));
};

Merge2MissionUnitsLibrary.prototype.collectUnitReward = function (code, stage) {
    if (!this.isUnclaimed(code, stage)) {
        return undefined;
    }

    delete this.unclaimed[code][stage];

    return RewardsConfig.Merge2MissionUnitReward;
};

Merge2MissionUnitsLibrary.prototype.collectGroupReward = function (group) {
    if (this.isGroupRewarded(group) || !this.isGroupCompleted(group)) {
        return undefined;
    }

    this.groupRewarded[group] = 1;

    return RewardsConfig.Merge2MissionGroupReward[group];
};

Merge2MissionUnitsLibrary.prototype.collectLibraryReward = function () {
    if (this.libraryRewarded || !this.isCompleted()) {
        return undefined;
    }

    this.libraryRewarded = true;

    return RewardsConfig.Merge2MissionLibraryReward;
};

Merge2MissionUnitsLibrary.prototype.listUnclaimedRewards = function () {
    const rewards = [];

    Merge2MissionFamilies.getGroups().forEach((group) => {
        Merge2MissionFamilies.getGroupItems(group).forEach((item) => {
            if (this.isUnclaimed(item.code, item.stage)) {
                rewards.push(RewardsConfig.Merge2MissionUnitReward);
            }
        });

        if (this.isGroupCompleted(group.name) && !this.isGroupRewarded(group.name)) {
            rewards.push(RewardsConfig.Merge2MissionGroupReward[group.name]);
        }
    });

    if (!this.libraryRewarded && this.isCompleted()) {
        rewards.push(RewardsConfig.Merge2MissionLibraryReward);
    }

    return rewards;
};

Merge2MissionUnitsLibrary.prototype.hasUnclaimedRewards = function () {
    return this.listUnclaimedRewards().length > 0;
};

Merge2MissionUnitsLibrary.prototype.getAllUnclaimedRewards = function () {
    return this.listUnclaimedRewards().reduce((total, reward) => RewardsList.sumRewards(total, reward), {});
};

Merge2MissionUnitsLibrary.prototype.getInfo = function () {
    const discovered = Merge2MissionFamilies.encodeCodes(cleverapps.listToBit(this.discovered));
    const unclaimed = Merge2MissionFamilies.encodeCodes(cleverapps.listToBit(this.unclaimed));

    return {
        discovered: Object.keys(discovered).length ? discovered : undefined,
        unclaimed: Object.keys(unclaimed).length ? unclaimed : undefined,
        activations: this.activations || undefined,
        groupRewarded: Object.keys(this.groupRewarded).length ? this.groupRewarded : undefined,
        libraryRewarded: this.libraryRewarded ? 1 : undefined
    };
};
